'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { EmptyState as EmptyStateBase } from '@/components/ui/empty-state';
import { CheckmarkCircle02Icon, Clock04IconSolid, HexagonIcon } from '@/components/ui/icon/glyphs';
import { Link } from '@/i18n/navigation';
import type { MarketsEmptyVariant } from './empty-state-variant';
export function EmptyState(t0) {
  const $ = _c(26);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const t = useTranslations("markets");
  if (variant === "endingSoon") {
    let t2;
    if ($[0] !== t) {
      t2 = t("empty.endingSoon.title");
      $[0] = t;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t) {
      t3 = t("empty.endingSoon.body");
      $[2] = t;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
      t4 = <EmptyStateBase size="page" icon={Clock04IconSolid} title={t2} description={t3} />;
      $[4] = t2;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  if (variant === "resolved") {
    let t2;
    if ($[7] !== t) {
      t2 = t("empty.resolved.title");
      $[7] = t;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== t) {
      t3 = t("empty.resolved.body");
      $[9] = t;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    let t4;
    if ($[11] !== t2 || $[12] !== t3) {
      t4 = <EmptyStateBase size="page" icon={CheckmarkCircle02Icon} title={t2} description={t3} />;
      $[11] = t2;
      $[12] = t3;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    return t4;
  }
  let t2;
  if ($[14] !== t) {
    t2 = t("empty.title");
    $[14] = t;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== t) {
    t3 = t("empty.body");
    $[16] = t;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== t) {
    t4 = t("empty.cta");
    $[18] = t;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== t4) {
    t5 = <AnimatedButton asChild={true}><Link href="/proposals">{t4}</Link></AnimatedButton>;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t5) {
    t6 = <EmptyStateBase size="page" icon={HexagonIcon} title={t2} description={t3} action={t5} />;
    $[22] = t2;
    $[23] = t3;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
}